import Quill from 'quill'

import BaseAdsBannerBlot from './base_banners'

export class AdsBannerVerticalBlot extends BaseAdsBannerBlot {
  static getBannerType() {
    return 'vertical'
  }
}

export function initBannersAdsBannerVertical() {
  const icons = Quill.import('ui/icons')
  icons['banner-vertical'] =
    '<div class="icon-banner-vertical">Vertical banner</div>'

  AdsBannerVerticalBlot.blotName = 'banner-vertical'
  AdsBannerVerticalBlot.tagName = 'div'
  AdsBannerVerticalBlot.className = 'ads-banner__container'

  Quill.register(AdsBannerVerticalBlot)
}
